import React, {Fragment} from 'react'
import Media from 'react-media';
import { graphql, StaticQuery, Link } from 'gatsby'
import CurlyArrowDown from '../../assets/curly-arrow-down.svg'
import { logEvent, pushToDataLayer } from '../Analytics'


class DownloadApp extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop'
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
			if (window.innerWidth > 1000) {
				this.setState({ device: 'desktop'})
			} else {
				this.setState({ device: 'mobile'})
			}
		}
    }

    render(){
        const {iPhone} = this.props.query;

        let mobileHeader = {
            fontSize: '1.2rem'
        }

        return(
            <section className="testa">
                <figure><CurlyArrowDown/></figure>
                <h3 style={this.state.device === 'mobile' ? mobileHeader : null}>Barnens digitala mattelärare. <br/> <a href="#"> Testa Albert gratis tillsvidare! </a></h3>
                
                <Media query="(max-width: 767px)">
                    {
                        matches =>
                            matches ? (
                                <>
                                <Link to="/register" onClick={ e => {logEvent(
                                    `Senior Prova gratis i 30 dagar mobile button`,
                                    `Senior Prova gratis i 30 dagar mobile button was clicked`
                                );
                                pushToDataLayer(
                                    'userClick',
                                    'Senior Prova Gratis I 30 Dagar Mobile Button',
                                    'Senior Prova Gratis I 30 Dagar Mobile Button Was Clicked'
                                )
                                }                                    
                                } className="prove">Prova gratis i 30 dagar</Link>
                                {/* <p style={{ margin: '1rem 0 0 0'}}>* 9 Januari 2020</p> */}
                                </>
                            ) : (
                                <Link to="/register"  onClick={ e => {logEvent(
                                    `Senior Prova gratis i 30 dagar desktop button`,
                                    `Senior Prova gratis i 30 dagar desktop button was clicked`
                                );
                                pushToDataLayer(
                                    'userClick',
                                    'Senior Prova Gratis I 30 Dagar Desktop Button',
                                    'Senior Prova Gratis I 30 Dagar Desktop Button Was Clicked'
                                )
                                
                                }                                    
                            }  className="prove">Prova gratis <span className="line">Ordinarie pris 99 kr/mån</span></Link>
                            )
                    }
                </Media>
            </section>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    iPhone: file(relativePath: {regex: "/iphone-mob/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <DownloadApp query={data} {...props}/>
        )}
    />
)
